/**
 * ServiceOrder Workflow Machine Config
 *
 * Generic pay-on-behalf order lifecycle (Milestone 07). Orders start at
 * `pendingPayment`; payment confirmation (Sprint 04 stub / Sprint 07) drives
 * `PAY`, fulfilment (Sprint 05) drives `FULFIL`.
 *
 * Pure statechart — no side effects. Guards live in
 * `guards/service-order.ts`; side effects live in the API service hooks.
 *
 * @see Documentation/Specification/020_Definitions/application-agnostic/ledger/ServiceOrder.md
 * @see sprints/2026-10/Milestone_07_SponsoredServices/sprint-03-service-order-foundation/README.md
 */
export const serviceOrderConfig = {
    id: 'service-order',
    initial: 'pendingPayment',
    states: {
        pendingPayment: {
            on: {
                PAY: { target: 'paid', guard: 'paymentConfirmed' },
                CANCEL: { target: 'cancelled' },
                EXPIRE: { target: 'expired' },
                FAIL: { target: 'failed' },
            },
        },
        paid: {
            on: {
                FULFIL: { target: 'fulfilled' },
                REFUND: { target: 'refunded' },
                FAIL: { target: 'failed' },
            },
        },
        fulfilled: {
            on: {
                REFUND: { target: 'refunded' },
            },
        },
        // Failed (payment reversal) and Expired orders refund back through the
        // receipt — M07 Sprint 07 T7.2 (both were terminal before the refund path).
        failed: {
            on: {
                REFUND: { target: 'refunded' },
            },
        },
        expired: {
            on: {
                REFUND: { target: 'refunded' },
            },
        },
        refunded: { type: 'final' },
        cancelled: { type: 'final' },
    },
};
//# sourceMappingURL=service-order.js.map